<template>
    <chart
        type="bar"
        :data="chartData"
    />
</template>

<script>
import chart from '@/components/ui/chart/chart.vue'

export default {
    components: {
        chart
    },
    computed: {
        sorted_years() { return this.years.slice().sort((a,b) => a - b)},
        years() { return this.$store.getters['card/inspections/years'] },
        stat() { return this.$store.state?.card?.inspections?.inspectionStatistic },
        amount() { return this.sorted_years.map(y => this.stat[y].plan.amount + this.stat[y].notplan.amount) },
        violations() { return this.sorted_years.map(y => this.stat[y].plan.violations + this.stat[y].notplan.violations) },
        chartData() {
            return {
                labels: this.sorted_years,
                datasets: [
                    {
                        label: 'Проверок всего',
                        fill: false,
                        backgroundColor: '#3498db',
                        borderColor: '#3498db',
                        pointBorderColor: '#3498db',
                        pointBackgroundColor: '#fff',
                        borderWidth: 1,
                        data: this.amount,
                    },
                    {
                        label: 'Проверок с нарушениями',
                        fill: false,
                        backgroundColor: '#e74c3c',
                        borderColor: '#e74c3c',
                        pointBorderColor: '#e74c3c',
                        pointBackgroundColor: '#fff',
                        borderWidth: 1,
                        data: this.violations,
                    }
                ]
            }
        }
    },
    mounted() { $('#tiles').trigger('resize') }
}
</script>